var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"logout"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Cerrando sesión")]),_c('img',{attrs:{"src":require("@/img/undraw_quitting_time_dm-8-t.svg")}})])
}]

export { render, staticRenderFns }